import $ from 'jquery';
window.jQuery = $;
require('jquery.easing');
// require('jquery.smoothscroll/dist/jquery.smoothscroll.min.js');

function CommonCtrl() {
	// this.init();
}

// CommonCtrl.prototype.init = function() {
//   $('a[href*="#"]').SmoothScroll({
//     duration: 1000,
//     easing: 'easeOutQuint'
//   });
// }


export default CommonCtrl;

